/**
 * @fileoverview
 * These two functions have been written to mirror the timestammp
 * input translation on the youtube web player.
 *
 * Please take a look at the test file to get a better feeling of the
 * use-cases that these two translation functions provide.
 */
/**
 *
 */
export function formatTimeToSeconds(time) {
    const seconds = Math.round(Number(time));
    if (isNaN(seconds)) {
        const isValidString = typeof time === 'string' && time.includes(':');
        if (isValidString) {
            const hoursMinutesSeconds = time.split(':');
            let totalSeconds;
            if (hoursMinutesSeconds.length === 2) {
                const [minutes, seconds] = hoursMinutesSeconds;
                totalSeconds = Number(seconds ?? 0) + Number(minutes ?? 0) * 60;
            }
            else {
                const [hours, minutes, seconds] = hoursMinutesSeconds;
                totalSeconds =
                    Number(seconds ?? 0) +
                        Number(minutes ?? 0) * 60 +
                        Number(hours ?? 0) * 60 * 60;
            }
            return totalSeconds;
        }
        else {
            return 0;
        }
    }
    else {
        return seconds;
    }
}
/**
 *
 */
export function formatTimeToHHMMSS(time, includeHoursIfZero = false) {
    return toHHMMSS(formatTimeToSeconds(time), includeHoursIfZero);
}
/**
 * Takes a number of seconds and splits it into an array of values for hour, minutes, seconds
 * @returns format [hours, minutes, seconds]
 */
export function toHHMMSSArray(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor(totalSeconds / 60) % 60;
    const seconds = totalSeconds % 60;
    return [hours, minutes, seconds];
}
/**
 *
 * @returns time string in format HH:MM:SS
 */
function toHHMMSS(totalSeconds, includeHoursIfZero = false) {
    return toHHMMSSArray(totalSeconds)
        .map((v) => (v < 10 ? '0' + v : v))
        .filter((v, i) => (includeHoursIfZero ? v : v !== '00' || i > 0))
        .join(':');
}
/**
 * Converts the current time in seconds to a plain text string.
 *
 * This function takes the current time in seconds and converts it into a human-readable
 * plain text string, formatted as hours, minutes, and seconds. It uses the provided
 * translation function `t` to generate the localized string.
 *
 * @param {number} currentTime - The current time in seconds.
 * @param {TFunction} t - The translation function to generate localized strings.
 * @returns {string} The formatted time string in plain text.
 */
export function currentTimeToPlainText(currentTime, t) {
    const hms = toHHMMSSArray(currentTime);
    // hours and minutes are 0, so just announce seconds
    if (hms[0] === 0 && hms[1] === 0) {
        return t('player:{{seconds}} seconds', { seconds: Math.floor(hms[2]) });
    }
    // hours are 0, so just announce minutes and seconds
    if (hms[0] === 0) {
        return t('player:{{minutes}} minutes, {{seconds}} seconds', {
            minutes: Math.floor(hms[1]),
            seconds: Math.floor(hms[2]),
        });
    }
    return t('player:{{hours}} hours, {{minutes}} minutes, {{seconds}} seconds', {
        hours: Math.floor(hms[0]),
        minutes: Math.floor(hms[1]),
        seconds: Math.floor(hms[2]),
    });
}
